import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log("vamos a ver si hay error")
        // console.log(next.handle(request))
        return next.handle(request).pipe(catchError(err => {
          // console.log("entramos en el error")
            if (err.status === 403) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload(true);
            }
            // console.log(err)
            
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))

    }
}
